import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import { createBrowserHistory } from "history"
import { routerMiddleware } from "connected-react-router"
import analytics from "../gaMiddleware"
import reducer from "./reducers"

if (typeof window === "undefined") {
  global.window = {}
}

export const history = createBrowserHistory()

const enhancer = compose(
  applyMiddleware(routerMiddleware(history)),
  applyMiddleware(analytics),
  applyMiddleware(thunk),
  window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
)

/* eslint-disable no-underscore-dangle */
const store = createStore(
  reducer(history),
  {}, // initial state
  enhancer
)
/* eslint-enable */

export default store



// WEBPACK FOOTER //
// ./src/redux/store.js